export function saveStats(id, type){
  const statsTimeoutID = window.setTimeout(function(){
    $.ajax({
      url: window.glob_obj.ajaxurl,
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'aw_save_stats',
        post_id: id,
        type: type,
        _ajax_nonce: window.glob_obj.aw_save_stats_nonce
      },
      success: function (response) {

      },
      error: function(error){
        console.log(error);
      }
    });
  }, 1000);
}

export function statsInit(){
  if (window.save_stats) {
    saveStats(window.save_stats.id, window.save_stats.type)
  }
}